import { useGetUserQuery } from "entities/user";

// Без права promo_actions_wheel раздел скрыт: create всё равно вернёт 403.
export const useCanManageRaffles = (): boolean => {
  const { data } = useGetUserQuery();
  return data?.promo_actions_wheel === true;
};
